import { useState } from 'react';
import { Button } from '@astryxdesign/core/Button';
import { List, ListItem } from '@astryxdesign/core/List';
import { Section } from '@astryxdesign/core/Section';
import { Heading, Text } from '@astryxdesign/core/Text';
import { VStack } from '@astryxdesign/core/VStack';
import { CalendarCheckIcon, CaretRightIcon } from '@phosphor-icons/react';
import { EmptyView } from '@/components/StateViews';
import { useTenant } from '@/features/tenant/context';
import { savedBookings } from '@/lib/storage';

/** Bookings opened on this device (access links are kept locally; no account needed). */
export function MyBookingsPage() {
  const t = useTenant();
  const [{ items, cutoff }] = useState(() => ({ items: savedBookings(t.slug), cutoff: Date.now() - 6 * 3600_000 }));
  const base = `/s/${t.slug}`;
  const upcoming = items.filter((b) => new Date(b.startsAt).getTime() > cutoff && b.status !== 'cancelled' && b.status !== 'no_show');
  const past = items.filter((b) => !upcoming.includes(b));
  return (
    <VStack as="main" gap={4} paddingInline={4} paddingBlockStart={4} className="app-page" maxWidth={720} style={{ marginInline: 'auto' }}>
      <Heading level={1}>Моя запись</Heading>
      {items.length === 0 ? (
        <EmptyView
          icon={<CalendarCheckIcon size={32} weight="duotone" />}
          title="Записей на этом устройстве нет"
          description="После записи ссылка на неё появится здесь. Регистрация не нужна."
          action={<Button label="Записаться" variant="primary" href={`${base}/booking`} />}
        />
      ) : (
        <>
          {upcoming.length > 0 ? (
            <VStack gap={2}>
              <Text weight="semibold">Предстоящие</Text>
              <Section padding={1} className="app-panel">
                <List hasDividers>
                  {upcoming.map((b) => <ListItem key={b.token} startContent={<CalendarCheckIcon size={22} color="var(--color-icon-accent)" aria-hidden />} label={b.title} description={`Код ${b.code}`} endContent={<CaretRightIcon size={16} color="var(--color-icon-secondary)" aria-hidden />} href={`${base}/booking/${encodeURIComponent(b.token)}`} />)}
                </List>
              </Section>
              <Button label="Записаться ещё" variant="secondary" href={`${base}/booking`} />
            </VStack>
          ) : null}
          {past.length > 0 ? (
            <List hasDividers header={<Text weight="semibold" color="secondary">Прошедшие и отменённые</Text>}>
              {past.map((b) => <ListItem key={b.token} label={b.title} description={`Код ${b.code}${b.status === 'cancelled' ? ' · отменена' : ''}`} href={`${base}/booking/${encodeURIComponent(b.token)}`} />)}
            </List>
          ) : null}
        </>
      )}
    </VStack>
  );
}
